import { render, staticRenderFns } from "./UnavailableExam.vue?vue&type=template&id=556ff164&scoped=true"
import script from "./UnavailableExam.vue?vue&type=script&lang=js"
export * from "./UnavailableExam.vue?vue&type=script&lang=js"
import style0 from "@/assets/stylesheets/components/shared/modal/UnavailableExam.scss?vue&type=style&index=0&id=556ff164&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556ff164",
  null
  
)

export default component.exports